<nb-card>
    <nb-card-header>
 
       
        Your recent transactions
   
        <button nbButton class="float-right" size="tiny" (click)="onClose()" status="danger">CLOSE</button>
   
    </nb-card-header>
    <nb-card-body>
        <ng2-smart-table class="my-table" [settings]="settings" [source]="source"></ng2-smart-table>
    </nb-card-body>
</nb-card>